const isNull = (value: any): value is null => {
  return value === null;
};

export default isNull;
